import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { Check, X } from "lucide-react";

import { cn } from "@/lib/utils";

function Switch({
  className,
  checked: controlledChecked,
  onCheckedChange,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  const isControlled = controlledChecked !== undefined;
  const [uncontrolledChecked, setUncontrolledChecked] = React.useState<boolean>(() => {
    const defaultChecked = (props as { defaultChecked?: boolean }).defaultChecked;
    return defaultChecked ?? false;
  });
  const checked = isControlled ? (controlledChecked as boolean) : uncontrolledChecked;

  const handleChange = (value: boolean) => {
    if (!isControlled) setUncontrolledChecked(value);
    if (onCheckedChange) onCheckedChange(value);
  };

  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      checked={checked}
      onCheckedChange={onCheckedChange}
      className={cn(
        "inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] focus-visible:border-ring focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50",
        checked ? "bg-success" : "bg-gray-400 dark:bg-gray-600",
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          "flex items-center justify-center size-4 rounded-full bg-white ring-0 transition-transform",
          checked ? "translate-x-[calc(100%-2px)]" : "translate-x-0"
        )}
      >
        {checked ? <Check size={10} className="text-success" /> : <X size={10} className="text-gray-600" />}
      </SwitchPrimitive.Thumb>
    </SwitchPrimitive.Root>
  );
}

export { Switch };
